import { useQuery } from '@tanstack/react-query';
import { OneOnOneSettingsPageReactQueryKeys } from 'screens/oneOnOneRabbit/SettingsPage/constants/OneOnOneSettingsPageReactQueryKeys';

import { getEventTemplateAgenda, getRegularTemplateAgenda } from '../services';

export const useOneOnOneRegularTemplateAgenda = () =>
  useQuery([OneOnOneSettingsPageReactQueryKeys.oneOnOneAdminAgenda, 'REGULAR'], () => getRegularTemplateAgenda());

export const useOneOnOneEventTemplateAgenda = () =>
  useQuery([OneOnOneSettingsPageReactQueryKeys.oneOnOneAdminAgenda, 'EVENT_BASED'], () => getEventTemplateAgenda());
